import { log } from 'utils/errorLogger'
import { STATES, COUNTRIES, ICountry } from 'constants/countriesStates'
import { NON_ALPHA_REGEX } from 'constants/regex'

export const lookupCountryByStateCode = (code: string = ''): ICountry | void => {
  const countryCode = Object.keys(STATES).find((stateObjKey: string) =>
    STATES[stateObjKey as keyof typeof STATES].find(state => {
      const matchesStateCode = code.toUpperCase() === state.abbr.toUpperCase()
      const matchesStateName = code.toUpperCase() === state.name.toUpperCase()
      return matchesStateCode || matchesStateName
    })
  )
  if (countryCode) return COUNTRIES.find(item => item.code === countryCode)
  const error = new Error(`Unable to find country for the following: ${code}`)
  return log('locations', error)
}

export const lookupCountryNameByStateCode = (code: string = '') => {
  const country = lookupCountryByStateCode(code)
  if (country) return country.name
  const error = new Error(`Unable to find country name for the following: ${code}`)
  return log('locations', error)
}

export const lookupCountryByCountryCode = (code: string = '') => {
  code = code.replace(NON_ALPHA_REGEX, '') // remove non-alpha characters
  const country = COUNTRIES.find(c => c.code === code)
  if (country) return country.name
  const error = new Error(`Unable to find country name for the following: ${code}`)
  return log('locations', error)
}

export const lookupStateName = (code: string = ''): string => {
  code = code.replace(NON_ALPHA_REGEX, '') // remove non-alpha characters
  code = code.toUpperCase()
  const usStateCandidate = STATES.US.find(item => item.abbr === code)
  const caStateCandidate = STATES.CA.find(item => item.abbr === code)
  if (usStateCandidate) return usStateCandidate.name
  if (caStateCandidate) return caStateCandidate.name
  // in the case where no location is found, return the state code given
  return code
}

export const lookupStateCode = (name: string = '') => {
  name = name.toUpperCase()
  const usStateCandidate = STATES.US.find(item => item.name.toUpperCase() === name)
  const caStateCandidate = STATES.CA.find(item => item.name.toUpperCase() === name)
  if (usStateCandidate) return usStateCandidate.abbr
  if (caStateCandidate) return caStateCandidate.abbr
  const error = new Error(`Unable to find state code for the following: ${name}`)
  return log('locations', error)
}
